import type { Resource } from '../../';
export const country_countries_NO: Resource = {"default":"Norway"};
